import Input from "components/Input";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import styles from "../staff.module.scss";
import AccordionWrapper from "./AccordionWrapper";
import LeavesInput from "./LeavesInput";
import Select from "components/Select";
const RadioInputs = ({ inputChange, fields, active = "", name }) => {
  return (
    <div
      className={
        "radio-list d-flex justify-content-between gap-sm " +
        styles["radio-list-flex"]
      }
    >
      {fields.map((res) => (
        <div className="ch-radio" style={{ overflow: "visible" }} key={res.key}>
          <label>
            <input
              type="radio"
              name={name}
              value={res.value}
              checked={active === res.value}
              onChange={inputChange}
            />
            <span>{res.text}</span>
          </label>
        </div>
      ))}
    </div>
  );
};
const OtherCompensationInputs = ({
  t,
  inputChange,
  isNumberKey,
  isCanAdminSeeHourlyRate,
  hourlyRate,
  setState,
  performanceReviewId,
  reviewFormList,
  states,
  reOpen,
  setReOpen,
  parentClass,
  fieldIndex,
  globalStaffPage,
  resetValues,
}) => {
  const {
    leaves,
    loadingLeaveDetail,
    annualSalary,
    commission_radio,
    commission_input_text,
    bonus_input_text,
    bonus_input_radio,
    bonus_annual_bonus_input_text,
    bonus_signing_input_text,
    EducationAllowance,
    OtherAllowance,
    UniformAllowance,
    TravelAllowance,
    vacationPaidOff,
    officeIds,
  } = states;
  const onRadioChangeHandler = (e) => {
    const { name, value } = e.target;
    inputChange({
      target: {
        name: name.split("-")[0],
        value,
      },
    });
  };
  return (
    <AccordionWrapper
      heading={t("staff.compensation")}
      reOpen={reOpen}
      setReOpen={setReOpen}
      parentClass={parentClass}
    >
      <div className={`bg-white ${styles["mb-10"]} ${styles["inline-form-space-fix"]} ${styles["p-20"]} ${styles["rounded-6"]}`}>
        <Text size="15px" weight="600" color="#2D3245" className={`${styles["form-title"]}`}>
          {t("staff.salary")}
        </Text>
        {isCanAdminSeeHourlyRate && (
          <Input
            Title={t("staff.hourlyRate")}
            Type="text"
            Placeholder={t("form.placeholder1", {
              field: t("staff.hourlyRate"),
            })}
            Name={"hourlyRate"}
            HandleChange={isNumberKey}
            HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
            Value={hourlyRate}
          />
        )}

        <Input
          Title={t("staff.annualSalary")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("staff.annualSalary"),
          })}
          Name={"annualSalary"}
          MaxLength={12}
          HandleChange={isNumberKey}
          HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          Value={annualSalary}
        />
      </div>
      <div className={`bg-white ${styles["mb-10"]} ${styles["inline-form-space-fix"]} ${styles["p-20"]} ${styles["rounded-6"]}`}>
        <Text size="15px" weight="600" color="#2D3245" className={`${styles["form-title"]}`}>
          {t("staff.commission")}
        </Text>
        <RadioInputs
          inputChange={onRadioChangeHandler}
          name={"commission_radio-" + fieldIndex}
          active={commission_radio}
          fields={[
            {
              key: "commission_percentage_radio",
              value: "1",
              text: t("staff.commissionPercentageRadio"),
            },
            {
              key: "commission_fixed_ratio_radio",
              value: "2",
              text: t("staff.commissionFixedAmountRadio"),
            },
          ]}
        />
        <Input
          Title=""
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: "",
          })}
          Name={"commission_input_text"}
          Value={commission_input_text}
          HandleChange={inputChange}
          // HelperLabel={
          //   <strong>
          //     {commission_radio === "2" ? t("superAdmin.cad") : "%"}
          //   </strong>
          // }
          MaxLength={100}
        />
      </div>

      <div className={`bg-white ${styles["mb-10"]} ${styles["inline-form-space-fix"]} ${styles["p-20"]} ${styles["rounded-6"]}`}>
        <Text size="15px" weight="600" color="#2D3245" className={`${styles["form-title"]}`}>
          {t("staff.bonus")}
        </Text>
        <Input
          Title={t("staff.annualBonus")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("staff.annualBonus"),
          })}
          Name={"bonus_annual_bonus_input_text"}
          MaxLength={100}
          HandleChange={inputChange}
          // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          Value={bonus_annual_bonus_input_text}
        />
        <RadioInputs
          inputChange={onRadioChangeHandler}
          name={"bonus_input_radio-" + fieldIndex}
          active={bonus_input_radio}
          fields={[
            {
              key: "bonus_performance_percentage",
              value: "1",
              text: t("staff.performanceBonusPercentage"),
            },
            {
              key: "bonus_performance_dollar",
              value: "2",
              text: t("staff.PerformanceBonusCurrency"),
            },
          ]}
        />
        <Input
          Title=""
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: "",
          })}
          Name={"bonus_input_text"}
          HandleChange={inputChange}
          Value={bonus_input_text}
          // HelperLabel={
          //   <strong>
          //     {bonus_input_radio === "2" ? t("superAdmin.cad") : "%"}
          //   </strong>
          // }
          MaxLength={100}
        />
        <Input
          Title={t("staff.signingBonus")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("staff.signingBonus"),
          })}
          Name={"bonus_signing_input_text"}
          MaxLength={100}
          HandleChange={inputChange}
          // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          Value={bonus_signing_input_text}
        />
      </div>
      <div className={`bg-white ${styles["mb-10"]} ${styles["inline-form-space-fix"]} ${styles["p-20"]} ${styles["rounded-6"]}`}>
        <Text size="15px" weight="600" color="#2D3245" className={`${styles["form-title"]}`}>
          Allowances
        </Text>
        <Input
          Title={"Travel"}
          Type="text"
          Placeholder={"0"}
          Name={"TravelAllowance"}
          MaxLength={100}
          HandleChange={inputChange}
          // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          Value={TravelAllowance}
        />
        <Input
          Title="Continuing Education"
          Type="text"
          Placeholder={"0"}
          Name={"EducationAllowance"}
          HandleChange={inputChange}
          Value={EducationAllowance}
          // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          MaxLength={100}
        />
        <Input
          Title={"Uniform Allowance"}
          Type="text"
          Placeholder={"0"}
          Name={"UniformAllowance"}
          MaxLength={100}
          HandleChange={inputChange}
          // HelperLabel={<strong>{t("superAdmin.cad")}</strong>}
          Value={UniformAllowance}
        />
        <div className={`c-field ${styles["mb-20"]}`}>
          <label>{"Other"}</label>
          <textarea
            className="c-form-control resize-none"
            placeholder={"E.g., Relocation expense"}
            name="OtherAllowance"
            maxLength={100}
            value={OtherAllowance}
            onChange={inputChange}
          ></textarea>
        </div>
      </div>
      {!loadingLeaveDetail && (
        <LeavesInput
          leaves={leaves}
          inputChange={inputChange}
          vacationPaidOff={vacationPaidOff}
          onChange={setState}
          resetValues={resetValues}
        />
      )}
      {((isCanAdminSeeHourlyRate && !globalStaffPage) ||
        (globalStaffPage && officeIds?.length === 1)) && (
        <Select Classes={`mb-0 ${styles["mt-20"]}`}
          Title={t("form.fields.selectPerformanceReview")}
          selectedOption={performanceReviewId ? performanceReviewId : "0"}
          Options={reviewFormList}
          Name={"performanceReviewId"}
          HandleChange={inputChange}
        />
      )}
    </AccordionWrapper>
  );
};
export default withTranslation()(OtherCompensationInputs);
